<template>
    <!-- 添加/修改文件夹 -->
    <el-dialog :title="title" width="30%" :visible="isShow" @close="$emit('hide')">
        <el-form ref="modifyNameForm" :model="{ 'name': folderName }"
            :inline="false"
            label-position="top"
            :rules="{ name: [
            { required: true, message: '必填项', trigger: 'blur' },
            { max: 20, message: '长度20个字符', trigger: 'blur' }
            ] }">
            <el-form-item label="名称" required prop="name" label-width="80px">
                <el-input v-model="folderName" class="form-folder-input"></el-input>
            </el-form-item>
            <el-form-item v-if="levelList.length === 5" label="过期时间" label-width="80px">
                <el-date-picker
                    v-model="invalidTime"
                    class="form-folder-input"
                    align="center"
                    type="date"
                    :default-value="invalidTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button :loading="isSubmitting" type="primary" @click="onSubmit">{{ submitName }}</el-button>
                <el-button @click.stop="$emit('hide')">取消</el-button>
            </span>
    </el-dialog>
</template>
<script>
import api from '@/api/index.js'
export default {
    name: 'AddFolderDialog',
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        isNew: {
            type: Boolean,
            default: true
        },
        currStepName: {
            type: String,
            default: ''
        },
        value: {
            type: Object,
            default: () => ({})
        },
        levelList: {
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            folderName: this.value.name || '',
            invalidTime: this.value.invalidTime || null, // 过期时间
            isSubmitting: false, // 提交中
            pickerOptions: {
                shortcuts: [
                    {
                        text: '明天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '三天后',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '一周后',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '两周后',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
                            picker.$emit('pick', date);
                        }
                    }
                ]
            }
        }
    },
    computed: {
        title () {
            return this.isNew ? '添加' + this.currStepName : '修改名称'
        },
        submitName () {
            return this.isNew ? '确定' : '保存'
        }
    },
    created () {
    },
    methods: {
        setValue (name) {
            this.folderName = name
        },
        // 确认添加，修改
        onSubmit () {
            this.$refs.modifyNameForm.validate(result => {
                if (result === true) {
                    if (this.isNew) {
                        this.addFolder()
                    } else {
                        this.updateFolder()
                    }
                }
            })
        },
        async addFolder () {
            try {
                this.isSubmitting = true
                const resp = await api.addFolder({
                    parentId: this.value.id, // 父级id 如果没有就是0
                    folderName: this.folderName,
                    level: this.levelList.length || 1,
                    levels: this.levelList.join(','),
                    invalidTime: this.invalidTime || undefined
                })
                if (resp.success) {
                    this.$message.success('添加成功');
                    this.$emit('hide', true)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.isSubmitting = false
            }
        },
        async updateFolder () {
            try {
                this.isSubmitting = true
                const resp = await api.updateFolder({
                    folderId: this.value.modifyId,
                    folderName: this.folderName,
                    invalidTime: this.invalidTime || undefined
                })
                if (resp.success) {
                    this.$message.success('保存成功');
                    this.$emit('hide', true)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.isSubmitting = false
            }
        }
    }
}
</script>>
<style lang="scss" scopes>
.form-folder-input {
    width: 100% !important;
}
</style>